// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55beac6e","453":"5f74e72f","455":"c80e6560","977":"4c5dd2d2"}[chunkId] + ".chunk.js";
};